(function() {
  const ZOOM_RATIO = 2;
  const MOBILE_BREAKPOINT = 768;

  // Fullscreen lightbox s šípkami
  function createLightbox(images, startIndex) {
    let currentIndex = startIndex;

    // Vytvor overlay
    const overlay = document.createElement('div');
    overlay.style = `
      position: fixed; top:0; left:0; width:100vw; height:100vh;
      background: rgba(0,0,0,0.9);
      display: flex; justify-content: center; align-items: center;
      z-index: 99999;
      user-select: none;
    `;
    overlay.setAttribute('aria-hidden', 'true');

    // Vytvor obrazok
    const img = document.createElement('img');
    img.style = 'max-width: 90vw; max-height: 90vh; box-shadow: 0 0 20px rgba(0,0,0,0.8);';
    img.src = images[currentIndex].src;

    // Vytvor sipky
    const leftArrow = document.createElement('button');
    leftArrow.innerHTML = '&#10094;'; // šípka vľavo ‹
    leftArrow.style = arrowStyle() + ' left: 20px;';

    const rightArrow = document.createElement('button');
    rightArrow.innerHTML = '&#10095;'; // šípka vpravo ›
    rightArrow.style = arrowStyle() + ' right: 20px;';

    // Pridaj eventy na šípky
    leftArrow.onclick = e => {
      e.stopPropagation();
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      img.src = images[currentIndex].src;
    };
    rightArrow.onclick = e => {
      e.stopPropagation();
      currentIndex = (currentIndex + 1) % images.length;
      img.src = images[currentIndex].src;
    };

    // Klik na overlay zatvori
    overlay.onclick = () => document.body.removeChild(overlay);

    overlay.appendChild(leftArrow);
    overlay.appendChild(img);
    overlay.appendChild(rightArrow);
    document.body.appendChild(overlay);

    // Zablokuj scroll pozadia
    document.body.style.overflow = 'hidden';

    // Po zatvorení obnov scroll
    overlay.addEventListener('click', () => {
      document.body.style.overflow = '';
    });
  }

  function arrowStyle() {
    return `
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255,255,255,0.2);
      border: none;
      color: white;
      font-size: 3rem;
      cursor: pointer;
      padding: 0 12px;
      user-select: none;
      border-radius: 4px;
      transition: background 0.3s;
      z-index: 100000;
    `;
  }

  // Pôvodný hover zoom
  function createOverlay(image) {
    const overlay = document.createElement('div');
    overlay.setAttribute('class', 'image-magnify-full-size');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundImage = `url('${image.src}')`;
    image.parentElement.insertBefore(overlay, image);
    return overlay;
  }

  function moveWithHover(image, event, zoomRatio, overlay) {
    const ratio = image.height / image.width;
    const container = event.target.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (overlay.clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((overlay.clientWidth * ratio) / 100)}%`;
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }

  function magnify(image, zoomRatio) {
    const overlay = createOverlay(image);
    overlay.onclick = () => overlay.remove();
    overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay);
    overlay.onmouseleave = () => overlay.remove();
  }

  // Inicializacia
  function enableZoomOnHoverOrFullscreen() {
    const images = Array.from(document.querySelectorAll('.image-magnify-hover'));
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      // Mobile - pôvodný hover zoom
      images.forEach(image => {
        image.style.cursor = 'zoom-in';
        image.onclick = (event) => {
          magnify(image, ZOOM_RATIO);
          moveWithHover(image, event, ZOOM_RATIO, document.querySelector('.image-magnify-full-size'));
        };
      });
    } else {
      // Desktop - fullscreen lightbox so šípkami
      images.forEach((image, index) => {
        image.style.cursor = 'zoom-in';
        image.onclick = (event) => {
          event.preventDefault();
          createLightbox(images, index);
        };
      });
    }
  }

  // Spusti po načítaní DOMu
  document.addEventListener('DOMContentLoaded', enableZoomOnHoverOrFullscreen);

  // Voliteľne: aktualizuj pri resize, ak chceš dynamicky meniť správanie
  window.addEventListener('resize', () => {
    // Pre jednoduchosť refreshni stránku na resize (alebo môžeš zrušiť a znova zavolať enableZoomOnHoverOrFullscreen)
    // location.reload();
  });
})();
